import { render, staticRenderFns } from "./PanelNotification.vue.js?vue&type=template&id=5410e558&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PanelNotification.vue?vue&type=template&id=5410e558&scoped=true"
import script from "./PanelNotification.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PanelNotification.vue?vue&type=script&lang=js"
export * from "./PanelNotification.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PanelNotification.vue?vue&type=script&lang=js"
import style0 from "./PanelNotification.vue.scss?vue&type=style&index=0&id=5410e558&prod&lang=scss&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PanelNotification.vue?vue&type=style&index=0&id=5410e558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5410e558",
  null
  
)

export default component.exports